// extracted by mini-css-extract-plugin
module.exports = {"base":"IjZq5H","graphics":"JU_iZQ","path":"-lXMwP","animate":"tyYOEH","presentation":"_3Jm16H","rotate":"_12h3un","dash":"_3PAM3U"};